Core.NewsEvents = {
    Listing: function () {
        Core.NewsEvents.Cache = {
            $newsEventListingItems: $('#newsEventListingItems'),
            $topic: $('#topicFilter'),
            $trialBtn: $('#trial'),
            $groupPrice: $('#groupPrice'),
            $newsEventListing: $('#news-event-listing')
        };

        var _isLoading = false,
            _pageNumber = 0,
            _pageLinkId = Core.NewsEvents.Cache.$newsEventListing.data('pageid');

        Core.RenderTemplate('#tpl-NewsEventListing', jsonResult, Core.NewsEvents.Cache.$newsEventListingItems);

        Core.Cache.$window.scroll(function () {
            if (Core.Cache.$window.scrollTop() + Core.Cache.$window.height() >= Core.Cache.$footer.offset().top && !_isLoading) {

                if (jsonResult.ItemCount > 0 && (jsonResult.ItemCount !== Core.NewsEvents.Cache.$newsEventListingItems.children().length)) {
                    _isLoading = true;
                    Core.ShowPageLoading();
                    _pageNumber += 1;
                    $.ajax({
                        url: '/newsandevents/list',
                        data: { pageLinkId: _pageLinkId, topic: Core.NewsEvents.Cache.$topic.val(), pageNumber: _pageNumber },
                        type: 'get',
                        dataType: 'json',
                        success: function (data) {
                            var source = $('#tpl-NewsEventListing').html();
                            var template = Handlebars.compile(source);

                            Core.NewsEvents.Cache.$newsEventListingItems.append(template(data));
                            _isLoading = false;
                            Core.HidePageLoading();
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            //todo: do something
                        }
                    });
                }
            }
        });

        Core.NewsEvents.Cache.$topic.on('change', function (e) {
            var _topicId = Core.NewsEvents.Cache.$topic.val();
            var url = _topicId === 0 ? '' : '?category=' + _topicId;
            window.location = location.protocol + '//' + location.host + location.pathname + url;
        });
    },
};